import { Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";

export interface ThemeToggleProps {
  isDark: boolean;
  onToggle: () => void;
  /** Accessible label for each direction of the switch. */
  labels: { switchToLight: string; switchToDark: string };
  className?: string;
}

/** Single sun/moon icon button that flips between light and dark. */
export function ThemeToggle({
  isDark,
  onToggle,
  labels,
  className,
}: ThemeToggleProps) {
  const label = isDark ? labels.switchToLight : labels.switchToDark;
  const Icon = isDark ? Sun : Moon;

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      title={label}
      className={cn(
        "inline-flex h-8 w-8 items-center justify-center rounded-lg text-surface-500 transition-colors hover:bg-surface-100 hover:text-surface-900",
        className,
      )}
    >
      <Icon className="h-4 w-4" aria-hidden />
    </button>
  );
}
